import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { StripeCardElementChangeEvent, StripeCardElementOptions, StripeElementLocale, StripeElementsOptions } from '@stripe/stripe-js';
import { StripeCardComponent, StripeInstance } from 'ngx-stripe';
import { Observable } from 'rxjs';
import { BaseComponent } from 'src/shared/abstracts/base.abstract';

import { StripeState } from '../../store/state/stripe.state';
import { ResetErrorStripe } from '../../store/actions/stripe.action';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-stripe-card-form',
    templateUrl: './stripe-card-form.component.html',
    styleUrls: ['./stripe-card-form.component.scss'],
})
export class StripeCardFormComponent extends BaseComponent implements OnInit {
    @Select(StripeState.showGenericError) public showGenericError$: Observable<boolean>;

    @Output() public launchPayment = new EventEmitter<void>();

    @Input() public stripe: StripeInstance;
    @Input() public amountControl: FormControl;

    @ViewChild(StripeCardComponent, { static: false }) public card: StripeCardComponent;

    public cardOptions: StripeCardElementOptions = {
        style: {
            base: {
                iconColor: '#9e9e9e',
                color: '#212121',
                fontWeight: '400',
                fontFamily: 'NotoSans-Regular, Helvetica, sans-serif',
                fontSize: '18px',
                '::placeholder': {
                    color: '#CFD7E0',
                },
            },
        },
    };

    public elementsOptions: StripeElementsOptions = {
        locale: 'fr',
    };

    public ccErrorMessage: string;
    public buttonDisabled: boolean = true;
    public showGenericError: boolean;

    private currentLang: string;
    private stripeLocale: StripeElementLocale;

    constructor(private translate: TranslateService, private store: Store) {
        super();
    }

    ngOnInit(): void {
        this.setupStripeLocale();
        this.uns = this.showGenericError$.subscribe((showError: boolean) => (this.showGenericError = showError));
    }

    public onCcInputsChange(event: StripeCardElementChangeEvent): void {
        if (event.error) {
            this.ccErrorMessage = event.error.message || null;
        } else {
            this.ccErrorMessage = null;
        }
        this.buttonDisabled = !event.complete;
        if (this.showGenericError) {
            this.store.dispatch(new ResetErrorStripe());
        }
    }

    public pay(): void {
        if ((this.amountControl && this.amountControl.invalid) || this.buttonDisabled) {
            this.amountControl.markAsTouched();
            return;
        }
        this.launchPayment.emit();
    }

    private setupStripeLocale(): void {
        this.currentLang = this.translate.currentLang;
        this.stripeLocale = this.currentLang as StripeElementLocale;
        this.elementsOptions.locale = this.stripeLocale;
    }
}
